import { render, staticRenderFns } from "./EventDetailsAttachments.vue?vue&type=template&id=5fc4c8d9&scoped=true&"
import script from "./EventDetailsAttachments.vue?vue&type=script&lang=ts&"
export * from "./EventDetailsAttachments.vue?vue&type=script&lang=ts&"
import style0 from "./EventDetailsAttachments.vue?vue&type=style&index=0&id=5fc4c8d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc4c8d9",
  null
  
)

export default component.exports